var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"chart-header"},[_c('a',{attrs:{"href":"/contents"}},[_c('Logo',{staticClass:"chart-header__logo"})],1),_vm._v(" "),_c('a',{staticClass:"chart-header__link-back btn btn--xs btn--secondary",attrs:{"href":"/contents"}},[_c('LeftArrow',{staticClass:"chart-header__link-back-icon"}),_vm._v("\n    Back\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }